import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 2.4rem;
  line-height: 2rem;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const MainArea = styled.div`
  position: relative;
  width: 100%;
  max-width: 90rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 6rem;
  min-height: 0;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  ${media.smaller`
    padding: 2rem;
  `};
`;

export const VideoFrame = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const NavButton = styled.button`
  position: absolute;
  ${p => (p.$side === 'left' ? 'left: 1rem;' : 'right: 1rem;')}
  top: 50%;
  transform: translateY(-50%);
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 3.4rem;
  line-height: 2rem;
  padding-bottom: 0.7rem;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }

  ${media.smaller`
    width: 3.2rem;
    height: 3.2rem;
    font-size: 3rem;
  `};
`;

export const ThumbStrip = styled.div`
  display: flex;
  gap: 0.8rem;
  padding: 1.2rem 1.6rem;
  overflow-x: auto;
  max-width: 100%;
`;

export const ThumbItem = styled.div`
  flex: 0 0 auto;
  width: 6rem;
  height: 6rem;
  border-radius: 0.4rem;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid ${p => (p.$selected ? '#fff' : 'transparent')};
  opacity: ${p => (p.$selected ? 1 : 0.6)};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    opacity: 1;
  }

  ${media.smaller`
    width: 5rem;
    height: 5rem;
  `};
`;

export const VideoThumb = styled.div`
  width: 100%;
  height: 100%;
  background: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.6rem;
`;
